import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import Tabs from '../../atoms/Tabs/Tabs'
import Filters from '../../templates/Filters/Filters';
import Image from '../../atoms/Image/Image';
// import locationIcon from '../../../assets/images/location.png'
import fuelIcon from '../../../assets/images/fuel-type.png'
import cancellationIcon from '../../../assets/images/clock-close.png'
import Button from '../../atoms/Button/Button';
import useRequest from '../../../context/useRequest';
const SearchPage = () => {
  const { sendRequest } = useRequest();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState({});
  const [searchResult, setSearchResult] = useState({});
  useEffect(() => {
    if (location.state?.data) {
      setSearchData(location.state.data?.search_data);
      setSearchResult(location.state.data?.search_results);
    }
  }, [location.state]);
  const handleBooking = async (bookingToken) => {
    // console.log('Received booking token:', bookingToken);
    try {
      if (!bookingToken) {
        console.error("Booking token is missing.");
        return;
      }

      const response = await sendRequest({
        method: 'POST',
        url: '/cab/fareQoute',
        body: {booking_token: bookingToken},
      });

      // console.log("API Response:", response);

      if (response?.data) {
        // console.log("Status is true, proceeding to navigate...");
        const { booking_token, vehicle_details, search_data, expiry } = response.data;

        if (booking_token) {
          navigate('/booking', {
            state: {
              bookingToken: booking_token,
              vehicleDetails: vehicle_details,
              searchData: search_data,
              expiryData: expiry,
            }
          });
        } else {
          console.error('Missing booking token in response data');
        }
      } else {
        console.error('Failed to fetch fare quote or missing data in response');
      }
    } catch (error) {
      console.error('Error during booking API call:', error);
    }
  };




  return (
    <>
      <div className='hero-section search-modify section-padding'>
        <Container>
          <Row>
            <Col className='col-12 '>
              <Tabs modifySearch={true} searchData={searchData} />
            </Col>

          </Row>
        </Container>
      </div>
      <div className='search-product section-padding'>
        <Container>
          <Row>
            <Col className='col-12 col-lg-3'>
              <Filters />
            </Col>
            <Col className='col-12 col-lg-9'>

              {searchResult?.results && searchResult.results.length > 0 ? (
                searchResult.results.map((result, index) => (
                  <div key={result.id || index} className="search-product--cab" >
                    <div className='search-product--cab-left w-100'>
                      <figure className='mb-3 col-lg-0 search-product--cab-left-image' >


                        <Image src={result.image} alt={result.name} width="450" height="350" />
                      </figure>
                      <div className="search-product--cab-left-info">
                        <h3 className='h5'>{result.name}</h3>
                        <ul className="search-product--cab-left-info-table">
                          <li className='mb-0'>{result.name}</li>
                          <li className='mb-0'>4 Seats</li>
                          {/* <li className='mb-0'>CNG</li> */}
                          {/* <li className='mb-0'>4 Hrs / 40 kms included</li> */}
                        </ul>

                        <div className="search-product--cab-left-details">
                          <h3 className='h6 mb-2'>Details</h3>
                          {/* <div className='search-product--cab-left-details-fare'>
                            <div className='search-product--cab-left-details-fare-left'>
                              <figure className='mb-0 search-product--cab-left-details-fare-left-icon'>
                                <img src={locationIcon} alt='subTitle' />
                              </figure>
                              {<h6 className='h6 mb-0'>Extra km fare</h6>}
                            </div>
                            <div className='search-product--cab-left-details-fare-right'>
                              <p className='mb-0'>₹16.0/km after 148 kms</p>
                            </div>
                          </div> */}
                          {/* <div className='search-product--cab-left-details-fare'>
                            <div className='search-product--cab-left-details-fare-left'>
                              <figure className='mb-0 search-product--cab-left-details-fare-left-icon'>
                                <img src={fuelIcon} alt='subTitle' />
                              </figure>
                              <h6 className='h6 mb-0'>Fuel Type</h6>
                            </div>
                            <div className='search-product--cab-left-details-fare-right'>
                              <p className='mb-0'>Refill breaks</p>
                            </div>
                          </div> */}
                          <div className='search-product--cab-left-details-fare'>
                            <div className='search-product--cab-left-details-fare-left'>
                              <figure className='mb-0 search-product--cab-left-details-fare-left-icon'>
                                <img src={cancellationIcon} alt='subTitle' />
                              </figure>
                              <h6 className='h6 mb-0'>Cancellation</h6>
                            </div>
                            <div className='search-product--cab-left-details-fare-right'>
                              <p className='mb-0'>Upto 5 hours before the pickup</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {console.log(result)}
                    <div className="search-product--cab-pricing">
                      <h4>₹{result.base_fare}</h4>
                      <Button
                        className="btn-custom"
                        onClick={async () => {
                          // console.log('Button clicked, invoking handleBooking...');
                          await handleBooking(result.booking_token);
                        }}
                        label="Book Now"
                      />

                    </div>
                  </div>


                ))
              ) : (
                <p className='text-center error' style={{border:"1px solid #d3d3d3"}}>No search results found.</p>
              )}
            </Col>
          </Row>
        </Container>
      </div>

    </>
  );
};

export default SearchPage;
